import React, { useState, useEffect, Suspense } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { toast } from "react-toastify";
import StatusFilter from "../../components/StatusFilter";
import OrderDetailsModal from "../../components/OrderDetailsModal";
import { useSelector } from "react-redux";
import { useSettings } from "../../context/SettingsContext";
const OrderCard = React.lazy(() => import("../../components/OrderCard"));

const OrdersTab = () => {
  const [orders, setOrders] = useState([]);
  const [filtered, setFiltered] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedStatus, setSelectedStatus] = useState("all");
  const [selectedOrder, setSelectedOrder] = useState(null);
  const user = useSelector((state) => state.auth.user);
const { settings } = useSettings();
  useEffect(() => {
    const fetchOrders = async () => {
      try {
        const res = await fetch(
          `${window.BASE_API_URL}orderlist/${user?.id}`
        );
        const data = await res.json();
        if (data.success) {
          setOrders(data.data || []);
          setFiltered(data.data || []);
        } else {
          toast.error("Failed to load orders");
        }
      } catch (error) {
        toast.error("Error fetching orders");
      } finally {
        setLoading(false);
      }
    };
    if (user?.id) fetchOrders();
  }, [user]);

  const handleFilterChange = (status) => {
    setSelectedStatus(status);
    if (status === "all") {
      setFiltered(orders);
    } else {
      setFiltered(orders.filter((o) => String(o.status) === status));
    }
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center h-40">
        <div className="animate-spin rounded-full h-10 w-10 border-t-4 border-amber-500"></div>
      </div>
    );
  }

  return (
    <div>
      <motion.h2
        initial={{ opacity: 0, y: -10 }}
        animate={{ opacity: 1, y: 0 }}
        className="text-2xl font-semibold text-amber-700 mb-4"
         style={{ color: settings?.cart_btn_color || "#111827" }}
      >
        My Orders
      </motion.h2>

      {/* Status Filter */}
      {/* <StatusFilter selected={selectedStatus} onChange={handleFilterChange} /> */}

      {filtered.length === 0 ? (
        <div className="text-center text-gray-500 text-lg mt-8">
          No orders found.
        </div>
      ) : (
        <motion.div
          layout
          className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 mt-6"
        >
          <Suspense fallback={<div>Loading...</div>}>
            <AnimatePresence>
              {filtered.map((order) => (
                <OrderCard
                  key={order.id}
                  order={order}
                  onOpen={setSelectedOrder}
                />
              ))}
            </AnimatePresence>
          </Suspense>
        </motion.div>
      )}

      {selectedOrder && (
        <OrderDetailsModal
          orderId={selectedOrder}
          onClose={() => setSelectedOrder(null)}
        />
      )}
    </div>
  );
};

export default OrdersTab;
